import { z } from 'zod';

function todayIsoDate(): string {
  return new Date().toISOString().slice(0, 10);
}

const IsoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD.');

const PositiveDecimalNumberSchema = z
  .number()
  .finite()
  .positive()
  .multipleOf(0.0001, 'Use no more than 4 decimal places.');

const NonNegativeDecimalNumberSchema = z
  .number()
  .finite()
  .min(0)
  .multipleOf(0.0001, 'Use no more than 4 decimal places.');

export const AccountSnapshotInputSchema = z
  .object({
    asOfDate: IsoDateSchema.default(todayIsoDate),
    nav: PositiveDecimalNumberSchema,
    cash: NonNegativeDecimalNumberSchema,
    marginUsed: NonNegativeDecimalNumberSchema,
    buyingPower: NonNegativeDecimalNumberSchema,
  })
  .superRefine((snapshot, ctx) => {
    if (snapshot.cash > snapshot.nav * 2) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['cash'],
        message: 'Cash cannot exceed 2x NAV. Check your figures.',
      });
    }

    if (snapshot.marginUsed > snapshot.nav * 5) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['marginUsed'],
        message: 'Margin used cannot exceed 5× NAV. Check your figures.',
      });
    }
  });

export type AccountSnapshotInput = z.infer<typeof AccountSnapshotInputSchema>;
